import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasChunkError: boolean;
}

class ChunkLoadErrorBoundary extends React.Component<Props, State> {
  private onlineHandler: (() => void) | null = null;

  constructor(props: Props) {
    super(props);
    this.state = { hasChunkError: false };
  }

  static getDerivedStateFromError(error: Error): State | null {
    if (error.name === 'ChunkLoadError' || error.message?.includes('Loading chunk')) {
      return { hasChunkError: true };
    }
    return null;
  }

  componentDidUpdate(_prevProps: Props, prevState: State): void {
    if (!this.state.hasChunkError || prevState.hasChunkError) return;

    if (navigator.onLine) {
      window.location.reload();
    } else {
      this.onlineHandler = () => window.location.reload();
      window.addEventListener('online', this.onlineHandler);
    }
  }

  componentWillUnmount(): void {
    if (this.onlineHandler) {
      window.removeEventListener('online', this.onlineHandler);
      this.onlineHandler = null;
    }
  }

  render(): React.ReactNode {
    if (this.state.hasChunkError) {
      return <></>;
    }
    return this.props.children;
  }
}

export default ChunkLoadErrorBoundary;
